const baseURL = 'https://pizarra.quickplate.cloud/';

export default baseURL;
